/* Display only: never change Shopify or Live Product Options price inputs. */
(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('pp-vat-context')?.textContent || '{}');
  const uk = config.country === 'GB' && config.currency === 'GBP';
  const money = cents => new Intl.NumberFormat('en-GB', {style:'currency', currency:config.currency || 'GBP'}).format(cents / 100);
  const amounts = (cents, included = config.included, taxable = true) => {
    cents = Math.round(Number(cents));
    const rate = uk && !config.exempt && taxable ? 0.2 : 0;
    const net = included && rate ? Math.round(cents / (1 + rate)) : cents;
    const gross = included ? cents : cents + Math.round(cents * rate);
    return {net, gross, vat:gross - net, rate};
  };
  const markup = (cents, included = config.included, taxable = true, prefix = '') => {
    const p = amounts(cents, included, taxable);
    if (!Number.isFinite(p.gross)) return '';
    if (!uk) return `<span class="pp-vat-dual"><strong>${prefix}${money(p.gross)}</strong><small>${included ? 'Tax included' : 'Tax calculated at checkout'}</small></span>`;
    if (!p.rate) return `<span class="pp-vat-dual"><strong>${prefix}${money(p.gross)}</strong><small>No VAT charged</small></span>`;
    return `<span class="pp-vat-dual"><strong>${prefix}${money(p.gross)}</strong><small>inc VAT</small><span class="pp-vat-net">${prefix}${money(p.net)} ex VAT</span></span>`;
  };
  const setHTML = (el, html) => { if (el.innerHTML !== html) el.innerHTML = html; };
  const read = el => {
    const value = el?.textContent.match(/£\s*([\d,]+(?:\.\d+)?)/);
    return value ? Math.round(Number(value[1].replaceAll(',', '')) * 100) : NaN;
  };
  const decorate = (source, taxable, prefix = '', cents = read(source), included = config.included, html = '') => {
    if (!Number.isFinite(cents)) return;
    let display = source.nextElementSibling;
    if (!display?.classList.contains('pp-vat-display')) {
      display = document.createElement('span');
      display.className = 'pp-vat-display';
      source.after(display);
    }
    setHTML(display, html || markup(cents, included, taxable, prefix));
    source.classList.add('pp-vat-source');
    source.setAttribute('aria-hidden', 'true');
  };
  const summary = (p, cart = false) => `<div class="pp-vat-summary" aria-live="polite" aria-atomic="true"><div class="pp-vat-summary__total"><span>${cart ? 'Subtotal' : 'Order total'}${p.rate ? ' inc VAT' : ''}</span><strong>${money(p.gross)}${cart ? '' : ` <small>${p.rate ? 'inc VAT' : 'No VAT charged'}</small>`}</strong></div><div><span>${cart ? 'Excluding VAT' : 'ex VAT'}</span><span>${money(p.net)}</span></div><div><span>${cart ? 'UK VAT' : 'VAT'}${p.rate ? ' (20%)' : ''}</span><span>${money(p.vat)}</span></div>${cart ? '' : '<small class="pp-vat-rounding">Unit prices are rounded. Totals use your full quantity.</small>'}</div>`;
  const approvedAmounts = approved => {
    if (!approved || approved.currency !== config.currency || !Number.isSafeInteger(approved.total) || approved.total < 0 || typeof approved.included !== 'boolean' || typeof approved.taxable !== 'boolean') return null;
    return amounts(approved.total, approved.included, approved.taxable);
  };
  const updateProduct = (root, approved = root.ppApprovedPrice) => {
    if (!uk) return;
    const taxable = root.dataset.vatTaxable !== 'false';
    const verified = approved && approved.currency === config.currency && Number.isSafeInteger(approved.total) && approved.total >= 0;
    const approvedPrice = verified ? approvedAmounts(approved) : null;
    const chosenTier = verified ? root.querySelector('input[name="__TieredQuantityDiscounts"]:checked')?.closest('.pp-tier-item')?.querySelector('.pp-tier__unit') : null;
    root.classList.add('pp-vat-ready');
    root.querySelectorAll('.pp-tier__unit').forEach(source => {
      if (source !== chosenTier) decorate(source, taxable);
      else {
        const each = approved.total / approved.quantity;
        decorate(source, approved.taxable, '', each, approved.included, approvedPrice ? '' : `<span class="pp-vat-dual"><strong>${money(Math.round(each))}</strong><small>Tax confirmed at checkout</small></span>`);
      }
    });
    root.querySelectorAll('.pp-addon-price').forEach(source => decorate(source, taxable, '+'));
    const total = root.querySelector('#pp-total-price');
    const cents = read(total);
    if (!Number.isFinite(cents) || !total) return;
    const p = verified ? approvedPrice : amounts(cents, config.included, taxable);
    const nativeRow = total.closest('.pp-price-bar__row2');
    let display = nativeRow.nextElementSibling;
    if (!display?.classList.contains('pp-vat-order-display')) {
      display = document.createElement('div');
      display.className = 'pp-vat-order-display';
      nativeRow.after(display);
    }
    nativeRow.classList.add('pp-vat-source');
    nativeRow.setAttribute('aria-hidden', 'true');
    setHTML(display, p ? summary(p) : `<div class="pp-vat-summary" aria-live="polite"><div class="pp-vat-summary__total"><span>Approved pack price</span><strong>${money(approved.total)}</strong></div><small>Tax confirmed at checkout</small></div>`);
    const sticky = document.querySelector('.pp-sticky-bar__price');
    if (sticky) {
      const text = p ? p.rate ? `${money(p.gross)} inc VAT · ${money(p.net)} ex VAT` : `${money(p.gross)} · no VAT charged` : `${money(approved.total)} · tax confirmed at checkout`;
      if (sticky.textContent !== text) sticky.textContent = text;
    }
  };
  const cartAmounts = (cents, lines, included = config.included) => {
    if (!uk || typeof included !== 'boolean' || typeof config.exempt !== 'boolean' || !Number.isSafeInteger(cents) || cents < 0 || !Array.isArray(lines)) return null;
    if (lines.some(line => !Number.isSafeInteger(line.total) || line.total < 0 || typeof line.taxable !== 'boolean') || lines.reduce((sum, line) => sum + line.total, 0) !== cents) return null;
    // Round VAT per discounted taxable line, matching the visible line prices.
    const vat = lines.reduce((sum, line) => sum + amounts(line.total, included, line.taxable).vat, 0);
    return {gross:included ? cents : cents + vat, net:included ? cents - vat : cents, vat, rate:vat > 0 ? .2 : 0};
  };
  const refreshCart = form => {
    if (!form || !uk) return;
    const source = form.querySelector('[data-subtotal]');
    if (!source) return;
    const cents = source.dataset.ppSubtotal == null ? read(source) : Number(source.dataset.ppSubtotal);
    const lines = [...form.querySelectorAll('[data-pp-line-total]')].map(line => ({total:Number(line.dataset.ppLineTotal), taxable:line.dataset.ppTaxable === 'true' ? true : line.dataset.ppTaxable === 'false' ? false : null}));
    const p = cartAmounts(cents, lines);
    if (!p) return;
    const row = source.closest('.cart__subtotal-row,.pp-cart-summary__row--subtotal');
    if (!row) return;
    let display = row.nextElementSibling;
    if (!display?.classList.contains('pp-vat-cart-display')) {
      display = document.createElement('div');
      display.className = 'pp-vat-cart-display';
      row.after(display);
    }
    // Older app markup may have mounted its coupon UI in the net-price row.
    // Move the same node, preserving its inputs/listeners, before replacing VAT.
    display.querySelectorAll('[data-live-discount]').forEach(mount => display.after(mount));
    row.classList.add('pp-vat-source');
    row.setAttribute('aria-hidden', 'true');
    setHTML(display, summary(p, true));
  };
  window.PPVat = {amounts, approvedAmounts, cartAmounts, money, markup, updateProduct, refreshCart};
  const start = () => {
    document.querySelectorAll('form[data-location]').forEach(refreshCart);
    // LPO renders its SVG-only remove button asynchronously in this known mount.
    document.querySelectorAll('[data-live-discount]').forEach(mount => {
      const labelRemove = () => {
        mount.querySelectorAll('.cl-po--discount .cl-po--discount-tag > button').forEach(button => {
          if (!button.getAttribute('aria-label') && !button.getAttribute('aria-labelledby')) button.setAttribute('aria-label', 'Remove discount code');
        });
        mount.querySelectorAll('.cl-po--discount .cl-po--discount-input').forEach(row => {
          const input = row.querySelector('input');
          if (input && !input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) input.setAttribute('aria-label', 'Discount code');
          if (!row.parentElement.querySelector('.pp-cart-discount-caption')) {
            const caption = document.createElement('span');
            caption.className = 'pp-cart-discount-caption';
            caption.textContent = 'Discount code';
            row.before(caption);
          }
        });
      };
      labelRemove();
      new MutationObserver(labelRemove).observe(mount, {childList:true, subtree:true});
    });
    // Subtotals are native Ajax outputs; observe just these nodes, not the whole page.
    document.querySelectorAll('form[data-location] [data-subtotal]').forEach(source => {
      new MutationObserver(() => refreshCart(source.closest('form'))).observe(source, {childList:true, subtree:true, characterData:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
